<template>
    <div class="slide fp-noscroll" :style="slide.backgroundColor ? `background-color: ${slide.backgroundColor};` : 'transparent;'">
        <div class="bg-full" v-if="slide.photo" :style="`background-image: url(${slide.photo})`"></div>
        <div class="video-container">
            <div class="video-holder">
                <video :poster="photo" playsinline preload="none" controlsList="nodownload" ref="video" @mousemove="showPause" controls @pause="isPlaying = false" @play="isPlaying = true">
                    <source :src="video" type="video/mp4">
                    <img :src="photo" @load="onImgLoad">
                    Your browser does not support the video tag.
                </video>
                <!-- <div class="controls">
                    <a href="#" @click="playPause" :class="{'play': !isPlaying, 'pause': isPlaying, 'hide': hidePlayButton}"></a>
                </div> -->
            </div>
        </div>
        
        <app-footer :footer="slide.footnote" :details="slide.details"></app-footer>
    </div>    
</template>

<script>
//import debounce from 'lodash/debounce'
import AppFooter from './Footer'
export default {
    props: ['slide', 'photo','video', 'details', 'footnote'],
    data() {
        return {
            isPlaying: false,
            hidePlayButton: false,
            timeout: null
        }
    },
    components: {AppFooter},
    methods: {
        playPause() {
            if (this.isPlaying) {
                this.$refs.video.pause()
                this.playButtonCls = []
            } else {
                this.$refs.video.play()
                this.hidePlayButton = true
            }
            this.isPlaying = !this.isPlaying;
        },
        pause() {
            console.log('Video paused')
        },
        play() {
            console.log('Video playing')
        },
        // showPause: debounce(function() {
        //     clearTimeout(this.timeout)
        //     this.hidePlayButton = false
        //     this.timeout = setTimeout(() => (this.hidePlayButton = true), 3000)
        // }, 500),
        showPause()  {
            clearTimeout(this.timeout)
            this.hidePlayButton = false
            this.timeout = setTimeout(() => (this.hidePlayButton = true), 2000)
        },
        openSlidePanel() {
            this.$root.$emit('openSlidePanel', this.details)
        },
        onImgLoad() {
            console.log('Video image loaded');
        }
    }
}

</script>

<style scoped>
.slide {
    position: relative;
}
.video-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}
.video-holder {
    width: 100%;
    margin: auto;
}
video {
    width: 100%;
    max-height: calc(100vh - 160px);
}
.controls {
    display: flex;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -20px;
    margin-left: -20px;
}
a.play, a.pause {
  display: inline-block;
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background:rgba(0,0,0,0.4);
  cursor: pointer;
  transition: .3s all ease;
}
a.play:hover, a.pause:hover {
  background: rgba(204,0,0,0.4);
}
a.play:before {
  content: "";
  display: block;
  position: absolute;
  width: 0; 
  height: 0; 
  border-style: solid;
  border-width: 15px 0 15px 30px;
  border-color: transparent transparent transparent #ffffff;
  top: 15px;
  left: 20px;
}
a.pause:before {
  content: '';
  width: 5px;
  height: 30px;
  background: #fff;
  position: absolute;
  left: 20px;
  top: 15px;
}
a.pause:after {
  content: '';
  width: 5px;
  height: 30px;
  background: #fff;
  position: absolute;
  right: 20px;
  top: 15px;
}
a.pause.hide {
    display: none;
    /* transition: 2s all ease; */
}
.bg-full {
  position: absolute;
  z-index: -1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.5; 
  filter: blur(35px);
}
/* MEDIA QUERIES */
@media (max-width: 767px) {
    .video-container {
        height: 80%;
    }
}
@media (max-width: 575px) {
    .video-container {
        height: 60%;
    }
}
@media (min-width: 576px) {
    .video-container {
        padding: 0 50px;
    }
}
</style>